import { Row, Col, Form, Button, Input, Divider, Typography } from "antd";
import { Link } from "react-router-dom";
import { LockOutlined, EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import "../../styles/login.css";
import Logo from "../../assets/logo.png";

const { Text } = Typography;

export default function ResetPassword(){
  return(
    <>
      <div className="container">
        <Row style={{ height: "100vh", margin: 0 }}>
          <Col xs={24} sm={24} md={12} lg={12} xl={12} className="col-left">
            <div className="img-container">
              <img className="school-logo" src={Logo} alt="Nasarawa State University Logo" />
            </div>
            <div className="headline">
              <h1>
                Nasarawa State University, Keffi
              </h1>
              <Text style={{ 
                color: 'rgba(255,255,255,0.9)', 
                fontSize: '1.2em',
                fontWeight: 300,
                marginTop: '0.5em',
                display: 'block'
              }}>
                E-Bursary Management System
              </Text>
            </div>
            <div className="forgot-password">
              <Link to="/login" className="link">Back to Login</Link>
            </div>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={12} className="col-right">
            <div className="login-box">
              <div className="header">
                <h1>New Password</h1>
                <Text style={{ 
                  color: 'rgba(44, 62, 80, 0.7)', 
                  fontSize: '1.1em',
                  display: 'block',
                  marginBottom: '0.5em'
                }}>
                  Create a new secure password for your account
                </Text>
                <Divider />
              </div>
              <Form 
                wrapperCol={{
                  span: 24,
                }}
                size="large"
                layout="vertical">
                <Form.Item
                  name="password"
                  rules={[
                    {
                      required: true,
                      message: 'Please enter a new password',
                    },
                    {
                      min: 8,
                      message: 'Password must be at least 8 characters',
                    },
                    {
                      pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/,
                      message: 'Password must contain uppercase, lowercase, and number',
                    },
                  ]}>
                  <Input.Password 
                    size="large" 
                    prefix={<LockOutlined className="icon"/>} 
                    placeholder="Enter new password"
                    iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                  />
                </Form.Item>
                <Form.Item
                  name="passwordConfirm"
                  dependencies={['password']}
                  rules={[
                    {
                      required: true,
                      message: 'Please confirm your password',
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue('password') === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error('Passwords do not match'));
                      },
                    }),
                  ]}>
                  <Input.Password 
                    size="large" 
                    prefix={<LockOutlined className="icon"/>} 
                    placeholder="Confirm new password"
                    iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                  />
                </Form.Item>
                <Form.Item
                  wrapperCol={{
                    span: 24,
                  }}
                  className="submit-button-wrapper"
                >
                  <Button 
                    size="large" 
                    className="submit-button" 
                    htmlType="submit" 
                    block 
                    style={{
                      display: 'flex', 
                      justifyContent: 'center', 
                      alignItems: 'center'
                    }}
                  >
                    Update Password
                  </Button>
                </Form.Item>
                <div style={{ 
                  textAlign: 'center', 
                  marginTop: '1.5em',
                  paddingTop: '1.5em',
                  borderTop: '1px solid rgba(0,0,0,0.1)'
                }}>
                  <Text style={{ 
                    color: 'rgba(44, 62, 80, 0.6)', 
                    fontSize: '0.9em',
                    display: 'block',
                    lineHeight: '1.5'
                  }}>
                    Password requirements: 8+ characters with uppercase, lowercase, and number
                  </Text>
                </div>
              </Form>
            </div>
          </Col>
        </Row>
      </div>
    </>
  )
}
